export default __webpack_public_path__ + "static/media/mobile-bg-1.13d32ea8.jpg";